import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TicketsService } from '../../../../tickets.service';
import { CancelGiftRequest } from '../../../../../../../projects/shared-lib/src/lib/models/cancel-gift-request';
import { CancelGiftResponse } from '../../../../../../../projects/shared-lib/src/lib/models/cancel-gift-response';
import { MatButton } from '@angular/material/button';
import { MessageAction, MessageObserverService } from '../../../../../../../projects/shared-lib/src/lib/services/message-observer.service';

@Component({
    selector: 'tw-unsend-gift-dialog',
    templateUrl: './unsend-gift-dialog.component.html',
    imports: [
        TranslateModule,
        MatButton
    ],
    styleUrls: ['./unsend-gift-dialog.component.css']
})
export class UnsendGiftDialogComponent {
    isProcessing = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { sodId: number, email: string },
        private dialogRef: MatDialogRef<UnsendGiftDialogComponent>,
        private ticketService: TicketsService,
        private translate: TranslateService,
        private messageObserverService: MessageObserverService
    ) {}

    closeDialog() {
        this.dialogRef.close(false);
    }

    confirmUnsend() {
        if (this.isProcessing) {
            return;
        }

        this.isProcessing = true;

        const request: CancelGiftRequest = {
            ticketId: this.data.sodId
        };

        this.ticketService.cancelGift(request)
            .subscribe({
                next: (response: CancelGiftResponse) => {
                    console.log('Gift cancelled successfully:', response);
                    this.dialogRef.close(true);
                    this.reloadPage();
                },
                error: (e) => {
                    console.error('Failed to cancel gift', e);
                    this.messageObserverService.addMessage(<MessageAction>{
                        dialog: false,
                        message: this.translate.instant('client.tickets.cancelGiftError'),
                        translate: false,
                        snackBar: {},
                    });
                    this.isProcessing = false;
                    this.dialogRef.close(false);
                },
                complete: () => {
                    console.info('Gift cancellation complete');
                    this.isProcessing = false;
                }
            });
    }

    reloadPage() {
        setTimeout(() => {
            location.reload();
        }, 1000);
    }
}
